module.exports = __webpack_public_path__ + "img/default.1f352c0c.png";